import { Component, inject, OnInit } from '@angular/core';
import { number } from 'echarts';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { LargeArea } from 'src/app/Interfaces/Admin/charts/LargeChartArea.interface';
import { SimpleChartBar } from 'src/app/Interfaces/Admin/charts/SimpleCharBar.interface';
import { SimpleArea } from 'src/app/Interfaces/Admin/charts/SimpleChartArea.interface';
import { Data_Cont_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Reports/Data_Contribution_CCP.interface';
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-contributions-cdms',
    templateUrl: './contributions-cdms.component.html',
    styleUrls: ['./contributions-cdms.component.scss', '../../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class ContributionsCDMSComponent implements OnInit {

  //+================== VARIABLES GENERAL ==================+\\
  public CurrentDate!: Date

  //+================== VARIABLES DATA LIBRARIES ==================+\\
  public DataChartAreaCCP: SimpleArea = { Data: [], Date: [], SerieName: 'Contribuciones', Subtitle: ``, Title: 'Contribuciones totales CCP', Total: 0, load: false }

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //-========================= SERVICES =========================-\\
  public Service_CCP = inject(LIBRARYCCPService)

  public DataChartBar: SimpleChartBar = {
    Title: 'total CDMS',
    DataX: [],
    DataY: [],
    load: false
  }

  ngOnInit(): void {
    this.CurrentDate = new Date();
    this.Load_Cont_CCP();

  }

  //-================== FUNCTTION FOR LOAD CONT CCP ==================-\\
  private async Load_Cont_CCP(): Promise<void> {

    try {

      const resContributionCCP: any = await firstValueFrom(this.Service_CCP.Get_Contribution_CCP({ Type: 3, StartDate: '', EndDate: this.CurrentDate }))

      if (resContributionCCP.success) {

        const DataContribution: Data_Cont_CCP[] = resContributionCCP.operation.Data
        const totalContribution: number = resContributionCCP.operation.total

        const oldDate: Date = new Date(Math.min(...DataContribution.map((item: Data_Cont_CCP) => new Date(item.DateD).getTime())));

        this.DataChartAreaCCP = {
          ...this.DataChartAreaCCP,
          Data: DataContribution.map((item: Data_Cont_CCP) => item.DataD),
          Date: DataContribution.map((item: Data_Cont_CCP) => item.DateD),
          Subtitle: `Periodo: ${moment(oldDate).utc().format('MM/DD/YYYY')} - ${moment(this.CurrentDate).utc().format('DD/MM/YYYY')}`,
          Total: totalContribution,
          load: true
        };

        this.DataChartBar = {
          ...this.DataChartBar,
          DataX: ['CCP'],
          DataY: [this.DataChartAreaCCP.Total],
          load: true
        }

      }


    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error (contribuciones CCP)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });

    }

  }

  public allContributions(): number {

    return this.DataChartBar.DataY.reduce((total, item: number) => total + item, 0)
  }

}
